import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import { CookiesKeys } from 'enums/cookies-keys.enum';
import { IVipLevelsResponse } from 'models/vip/i-vip-level.interface';

export const getVipLevels = (signal: AbortSignal): Promise<AxiosResponse<IVipLevelsResponse>> => {
  return axios.get(`/api/v1/vip/levels/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};
